import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';

class NetworkPointDetailsOperatorInfoGeneralComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public generalExpanded: boolean = true;
    public networkPoint: NetworkPointDto;

    private possibleTsos: string[] = [];

    public newIndividualField: boolean = false;
    public newIndividualFieldKey: string;
    public newIndividualFieldValue: string;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit(): void {
        if (this.isCreateMode) {
            this.getTsos();
        }
    }

    public addAdjacentTso(): void {
        if (!this.networkPoint.adjacentTso0) {
            this.networkPoint.adjacentTso0 = [];
        }
        this.networkPoint.adjacentTso0.push('');
    }

    public removeAdjacentTso(index: number): void {
        this.networkPoint.adjacentTso0.splice(index, 1);
    }

    public addIndividualField(): void {
        if (!this.networkPoint.individualFields0) {
            this.networkPoint.individualFields0 = [];
        }
        this.networkPoint.individualFields0.push({
            [this.newIndividualFieldKey]: this.newIndividualFieldValue
        });
        this.newIndividualFieldKey = null;
        this.newIndividualFieldValue = null;
        this.newIndividualField = false;
    }

    public removeIndividualField(index): void {
        this.networkPoint.individualFields0.splice(index, 1);
    }

    private getTsos(): void {
        this.TransmissionSystemOperator.query(
            { detailLevel: 'MINIMAL' },
            (res: TsoMinimalDto[]) => {
                angular.forEach(res, (tso) => {
                    this.possibleTsos.push(tso.name);
                });
            }
        );
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoGeneral', {
    controller: NetworkPointDetailsOperatorInfoGeneralComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-general.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
